<div class="modal-header">
  <h4  class="modal-title h5" translate>Ban users of organization</h4>
  <button (click)="onCloseModal()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="search mb-3">
    <input (input)="onSearchForOrganization($event)" [placeholder]="('Search'|translate)+'...'" class="form-control"
      type="search">
    </div>
    <div [style.max-height.px]="500" class="scrollarea">
      <div class="list-group">
        @for (organization of filteredOrganizations; track organization) {
          <a (click)="onBan(organization)"
            class="list-group-item list-group-item-action">
            <div class="row align-items-center">
              <div class="col">
                <strong [style.max-width.px]="340" class="truncate d-block">
                  <ngb-highlight [result]="organization.description" [term]="searchedOrganizationTerm"
                  [title]="organization.description"></ngb-highlight>
                </strong>
                <span [style.max-width.px]="340" class="text-muted small d-block truncate">
                  <ngb-highlight [result]="organization.name" [term]="searchedOrganizationTerm"
                  [title]="organization.name"></ngb-highlight>
                </span>
              </div>
              <div class="col-auto">
                <span class="fa-solid fa-user-lock"></span>
              </div>
            </div>
          </a>
        }
      </div>
    </div>
  </div>
  <scitis-modal-footer
    (okButtonPressed)="onCloseModal()"
    [okButtonText]="'Close'|translate"
    [showCancelButton]="false">
  </scitis-modal-footer>